import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "../components/layout/layout.exports";
import AuthPages from "./AuthPages";
import ProtectedRoutes from "./ProtectedRoutes";


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login/*" element={<AuthPages />} />

      <Route
        path="/*"
        element={
          <AdminLayout>
            <ProtectedRoutes />
          </AdminLayout>
        }
      />

      <Route path="*" element={<Navigate to="/customers" replace />} />
    </Routes>
  );
};

export default AppRoutes;
